import Immutable from 'immutable';
import { normalize } from 'normalizr';
import { 
  FETCH_POSTS_REQUEST, FETCH_POSTS_SUCCESS, FETCH_POSTS_ERROR
} from '../constants/ActionTypes';
import { post as postScheme } from '../schema';
import humps from 'humps';

const initialState = Immutable.Map();

export default function profile(state = initialState, action) {
  switch (action.type) {
    case FETCH_POSTS_SUCCESS:
      const { result } = action;
      const camelized  = humps.camelizeKeys(result);
      const normalizedPosts = normalize(action.result.items, [ postScheme ]);
      return state.update('posts', posts =>
        posts
          .update('hasNext', value => action.result.hasNext)
          .update('items', items =>
            items.concat(Immutable.OrderedSet(normalizedPosts.result))
          )
      );
    case FETCH_POSTS_ERROR:
      console.log(action.response);
      return state;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/profile.js